import React from "react";
import svg10 from "../../../assets/svg/svg10.svg";
import svg41 from "../../../assets/svg/svg41.svg";
import svg136 from "../../../assets/svg/svg136.svg";
import svg137 from "../../../assets/svg/svg137.svg";
import svg138 from "../../../assets/svg/svg138.svg";
import svg139 from "../../../assets/svg/svg139.svg";
import { useNavigate } from "react-router-dom";

const items = [
  {
    title: "Utility Bill Payment",
    svg: svg136,
    desc: "Pay water, sanitation, and electricity bills instantly",
  },
  {
    title: "Manage Subscriptions",
    svg: svg137,
    desc: "Pay for TV, Wi-Fi, or any recurring service right from your Impala Digital Payments dashboard.Get notified before bills are due so you never miss a payment.",
  },
  {
    title: "Track & Budget",
    svg: svg138,
    desc: "Stay on top of your spending with automatic reports and transaction history...",
  },
  {
    title: "Airtime & Data Bundles",
    svg: svg139,
    desc: "Keep your teams connected with instant, bulk airtime and data top-ups.",
  },
];

function PersonalPayments() {
  const navigate = useNavigate();

   const handleRegister = async () => {
    window.location.href="https://app.impaladigitalpayment.com/#/registration"
  };
  return (
    <div className="flex   lg:flex-row flex-col justify-between">
      <div className="flex flex-col   w-full">
        <div className="text-ink text-[2.25rem] font-[600] leading-[2.625rem] lg:max-w-[24rem] w-full">
          Your Smart Personal Payment Assistant
        </div>
        <div className="mt-[1.25rem] text-body text-[.875rem] font-[400] leading-[1.5rem] lg:max-w-[16.75rem] w-full">
          No queues, no missed bills, no stress. Manage everything in real time
          from your phone or laptop.
        </div>
        <div className="mt-[4rem] gap-[.62rem] flex">
          {" "}
          <button
            className="cstm-btn-2 !w-[12.625rem] "
            onClick={handleRegister}
          >
            Create Account <img src={svg10} alt="svg10" />
          </button>
        </div>

        <div className="lg:mt-[9.06rem] mt-[3rem] flex text-center items-center justify-center">
          <img src={svg41} alt="svg41" />
        </div>
      </div>

      <div className="grid lg:grid-cols-2 grid-cols-1 gap-[1.5rem] lg:gap-[2rem]  w-full">
        {items &&
          items?.map((item, index) => {
            const marginTopClasses = [
              "lg:mt-[3rem]",
              "lg:mt-0",
              "lg:mt-[4.5rem]",
              "lg:mt-[1.5rem]",
            ];
            return (
              <div
                key={index}
                className={`rounded-[1.25rem] bg-white shadow-[0_2px_10px_0_rgba(0,0,0,0.07)] px-[2rem] py-[1.56rem] flex-shrink-0 ${marginTopClasses[index]}`}
              >
                <img src={item?.svg} alt={item?.svg} />
                <div className="text-ink mt-[1.37rem] text-[1.125rem] font-[600] leading-[1.625rem]">
                  {item?.title}
                </div>
                <div className="mt-[1.12rem] text-body text-[.875rem] font-[400] leading-[1.5rem] lg:max-w-[13.4375rem] w-full">
                  {item?.desc}
                </div>
                {index === 3 && (
                  <button className="mt-[3.94rem] bg-impalaRed hover:bg-impalaRedDark transition-colors text-white rounded-[624.9375rem] px-[1rem] py-[0.5rem] text-[.875rem] font-[400] flex items-center gap-[0.5rem]">
                    Top up
                    <img src={svg10} alt="svg10" />
                  </button>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default PersonalPayments;
